import { Icon, IconProps } from "@chakra-ui/react";

const PremiumStar = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 22 21" {...props}>
      <path
        d="M7.24423 6.33797L0.864231 7.26297L0.751231 7.28597C0.58017 7.33138 0.424226 7.42138 0.299323 7.54677C0.17442 7.67216 0.0850342 7.82846 0.0402929 7.9997C-0.00444843 8.17093 -0.00294197 8.35098 0.0446583 8.52144C0.0922587 8.69191 0.184247 8.84668 0.311231 8.96997L4.93323 13.469L3.84323 19.824L3.83023 19.934C3.81976 20.1109 3.8565 20.2874 3.93668 20.4455C4.01686 20.6035 4.13761 20.7374 4.28657 20.8335C4.43552 20.9295 4.60732 20.9843 4.78438 20.9921C4.96144 20.9999 5.1374 20.9605 5.29423 20.878L11.0002 17.878L16.6932 20.878L16.7932 20.924C16.9583 20.989 17.1377 21.0089 17.313 20.9817C17.4883 20.9545 17.6532 20.8812 17.7908 20.7692C17.9284 20.6573 18.0338 20.5107 18.0961 20.3446C18.1583 20.1785 18.1753 19.9988 18.1452 19.824L17.0542 13.469L21.6782 8.96897L21.7562 8.88397C21.8677 8.74674 21.9407 8.58242 21.968 8.40776C21.9952 8.23311 21.9757 8.05435 21.9113 7.8897C21.847 7.72505 21.7402 7.5804 21.6017 7.47048C21.4633 7.36056 21.2982 7.28931 21.1232 7.26397L14.7432 6.33797L11.8912 0.557969C11.8087 0.390504 11.6809 0.249484 11.5224 0.150874C11.3639 0.0522634 11.1809 0 10.9942 0C10.8075 0 10.6246 0.0522634 10.466 0.150874C10.3075 0.249484 10.1798 0.390504 10.0972 0.557969L7.24423 6.33797Z"
        fill="url(#paint0_linear_1741_5518)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1741_5518"
          x1="1.5"
          y1="8"
          x2="17.5"
          y2="20.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6B6B" />
          <stop offset="1" stopColor="#4ECDC4" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export default PremiumStar;
